import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select"; // Importar Select2 (react-select)
import { toast } from "react-toastify";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ApiService } from "../ApiService";
import { useParams } from "react-router-dom";

const API_url = process.env.REACT_APP_API_URL;

export const ModalNuevoProveedor = ({ isOpen = true, onClose, onSave, list_city, selectedSucursal }) => {
	const { authCode } = useParams();

	const [formData, setFormData] = useState({
		empresa: "",
		telefono: "",
		direccion: "",
		actividadComercial: "",
		personalACargo: "",
		email: "",
		ciudad: "",
	});

	const [ciudades, setCiudades] = useState([]);

	// Estados de error para cada campo
	const [errors, setErrors] = useState({
		empresa: false,
		telefono: false,
		direccion: false,
		actividadComercial: false,
		personalACargo: false,
		email: false,
		ciudad: false,
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		// Limpiar error cuando el usuario modifica el campo
		setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
	};

	const handleCityChange = (selectedOption) => {
		setFormData({
			...formData,
			ciudad: selectedOption ? selectedOption.value : "",
		});

		// Limpiar error cuando el usuario selecciona una ciudad
		setErrors((prevErrors) => ({ ...prevErrors, ciudad: false }));
	};

	const handleSave = async () => {
		// Validaciones
		let hasError = false;
		const newErrors = {};

		if (!formData.empresa.trim()) {
			newErrors.empresa = true;
			toast.error("El nombre de la empresa es obligatorio");
			hasError = true;
		}

		if (!formData.telefono.trim()) {
			newErrors.telefono = true;
			toast.error("El teléfono es obligatorio");
			hasError = true;
		} else if (!/^\d+$/.test(formData.telefono)) {
			newErrors.telefono = true;
			toast.error("El teléfono debe contener solo números");
			hasError = true;
		}

		if (!formData.direccion.trim()) {
			newErrors.direccion = true;
			toast.error("La dirección es obligatoria");
			hasError = true;
		}

		if (!formData.actividadComercial.trim()) {
			newErrors.actividadComercial = true;
			toast.error("La actividad comercial es obligatoria");
			hasError = true;
		}

		if (!formData.personalACargo.trim()) {
			newErrors.personalACargo = true;
			toast.error("El nombre del personal a cargo es obligatorio");
			hasError = true;
		}

		if (!formData.email.trim()) {
			newErrors.email = true;
			toast.error("El email es obligatorio");
			hasError = true;
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.email = true;
			toast.error("El email no es válido");
			hasError = true;
		}

		if (!formData.ciudad.trim()) {
			newErrors.ciudad = true;
			toast.error("La ciudad es obligatoria");
			hasError = true;
		}

		setErrors(newErrors);

		if (hasError) {
			return;
		}

		// Preparar el payload
		const payload = {
			city: formData.ciudad,
			company: formData.empresa,
			fullName_person: formData.personalACargo,
			fullPhone: formData.telefono,
			email: formData.email,
			direction: formData.direccion,
			activity: formData.actividadComercial,
		};

		try {
			const url = `api/company/supplier/insert?key_branch=${selectedSucursal}`;
			const options = {
				method: "POST",
				body: JSON.stringify(payload),
			};

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al registrar el proveedor");
			}

			// Notificar éxito y cerrar el modal
			toast.success("Proveedor registrado con éxito");

			onSave("supplier", {
				key_supplier: response?.key_supplier ?? 0,
				name: payload.company
			});

			onClose();
		} catch (error) {
			console.error("Error al registrar el proveedor:", error);
			toast.error("Error al registrar el proveedor. Intente nuevamente.");
		}
	};

	useEffect(() => {
		setCiudades(list_city);
	}, [list_city]);

	if (!isOpen) return null;

	return (
		<div className="modal-overlay-proveedor">
			<div className="modal-content-proveedor">
				<button className="close-modal-btn" onClick={onClose}>
					<FontAwesomeIcon icon={faTimes} />
				</button>
				<h2 className="modal-title-proveedor">Crear Proveedor</h2>
				<div className="modal-body-proveedor">
					{/* Lado Izquierdo */}
					<div className="modal-left-proveedor">
						<div className="form-group-old">
							<label className="txt-name-provider">
								Empresa<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${errors.empresa ? "input-error" : ""}`}
								type="text"
								name="empresa"
								value={formData.empresa}
								onChange={handleChange}
								placeholder="Nombre de la empresa"
							/>
						</div>
						<div className="form-group-old">
							<label className="txt-name-provider">
								Teléfono<span className="obligate">*</span>
							</label>
							<PhoneInput
								country={"bo"} // Código de país inicial (Bolivia, puedes ajustarlo según tu necesidad)
								value={formData.telefono}
								onChange={(phone) => {
									// `phone` devuelve la cadena con el código de país + número, ej: "59176050147"
									// Aquí puedes guardarlo directamente en formData sin el '+' ya que react-phone-input-2
									// devuelve el número sin el signo '+' al llamar al onChange (ej: "59176050147").
									setFormData((prevData) => ({ ...prevData, telefono: phone }));
									setErrors((prevErrors) => ({ ...prevErrors, telefono: false }));
								}}
								inputClass={`modal-input-old ${errors.telefono ? "input-error" : ""}`}
								placeholder="Teléfono"
							// Opcionalmente puedes controlar el formato, borrando el '+' al mostrar en pantalla
							// Sin embargo, react-phone-input-2 coloca el '+' por defecto.
							// Si quieres que se vea '+591 76050147', se verá así por defecto,
							// pero el valor ya se guarda sin '+'.
							/>
						</div>
						<div className="form-group-old">
							<label className="txt-name-provider">
								Dirección<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${errors.direccion ? "input-error" : ""}`}
								type="text"
								name="direccion"
								value={formData.direccion}
								onChange={handleChange}
								placeholder="Dirección"
							/>
						</div>
						<div className="form-group-old">
							<label className="txt-name-provider">
								Actividad comercial<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${errors.actividadComercial ? "input-error" : ""}`}
								type="text"
								name="actividadComercial"
								value={formData.actividadComercial}
								onChange={handleChange}
								placeholder="Actividad Comercial"
							/>
						</div>
					</div>

					{/* Lado Derecho */}
					<div className="modal-right-proveedor">
						<div className="form-group-old">
							<label className="txt-name-provider">
								Personal a cargo<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${errors.personalACargo ? "input-error" : ""}`}
								type="text"
								name="personalACargo"
								value={formData.personalACargo}
								onChange={handleChange}
								placeholder="Nombre del personal"
							/>
						</div>
						<div className="form-group-old">
							<label className="txt-name-provider">
								Email<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${errors.email ? "input-error" : ""}`}
								type="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
								placeholder="Email"
							/>
						</div>
						<div className="form-group-old" style={{ marginTop: "3px" }}>
							<label className="txt-name-provider">
								Ciudad<span className="obligate">*</span>
							</label>
							<Select
								className={`react-select-container ${errors.ciudad ? "input-error" : ""}`}
								options={ciudades}
								value={ciudades.find((ciudad) => ciudad.value === formData.ciudad)}
								onChange={handleCityChange}
								placeholder="Selecciona una ciudad"
								isClearable
							/>
						</div>
					</div>
				</div>
				<div className="modal-footer-proveedor">
					<button className="cancel-button-product" onClick={onClose}>
						Cancelar
					</button>
					<button className="save-button" onClick={handleSave}>
						Guardar
					</button>
				</div>
			</div>
		</div>
	);
};

export default ModalNuevoProveedor;
